import React from "react";
import "./style.scss";
import iconAgregar from "../../../../../assets/pepper-icons/rightbar/icon_agregar.svg";
import ScfoButton from "src/components/shared/ScfoButton";

export default function SubmitButton({
  submitForm,
  text,
  type = "submit",
  disabled = false,
  icon = iconAgregar,
  style = {},
  hidden = false,
}) {
  return (
    <ScfoButton
      type={type}
      variant="success"
      className="btn d-flex justify-content-center align-items-center"
      style={style}
      disabled={disabled}
      onClick={(e) => submitForm(e)}
    >
      <img
        style={{ height: "16px", width: "16px", marginRight: "7px" }}
        src={icon}
        className="iconColor"
        hidden={hidden}
        alt=""
      />
      {text}
    </ScfoButton>
  );
}
